import errorManager from '@/rollbar.js';

const setupListener = (select) => {
  const selectedOption = select.find('option:selected');
  if (selectedOption.length) {
    ToggleClass(selectedOption[0]);
  }

  select.on('select2:select', (e) => {
    const selectedElement = e.params.data.element;
    ToggleClass(selectedElement);
  });
};

const ToggleClass = (selected) => {
  const dataSet = selected.dataset;
  const togglerTarget = document.querySelectorAll(dataSet.togglerTarget);
  const togglerClass = dataSet.togglerClass;
  const disableClass = dataSet.disableClass;

  if (disableClass === 'true') {
    togglerTarget.forEach((target) => target.classList.remove(togglerClass));
  } else {
    togglerTarget.forEach((target) => target.classList.add(togglerClass));
  }
};

const init = (select) => {
  try {
    setupListener(select);
  } catch (e) {
    errorManager(e);
  }
};

window.SelectClassToggler = {
  init: init,
};
